'use strict';

var Backbone = require('backbone'),
  $ = require('jquery'),
  _ = require('underscore'),
  mediator = require('mediatorjs'),
  config = require('../../js/config'),
  PointyModalView = require('../../js/components/PointyModalView'),
  ChangeProjectNameTemplate = require('../../tmpl/client/design-center/change-name-confirm-modal.hbs'),
  ChangeProjectNameControl = Backbone.View.extend({

    template: ChangeProjectNameTemplate,

    minlength: 1,
    maxlength: 50,

    events: {
      click: 'openModal'
    },

    openModal: function() {

      if (!this.userModal) {

        this.innerContent = $(this.template({
          lengthRange: {
            min: this.minlength,
            max: this.maxlength
          }
        }));

        this.projectId = this.$el.data('project');

        this.bindEvents(this.innerContent);

        this.$headerTitle = $('#ProjectTitleContent');

        this.userModal = new PointyModalView({
          el: this.el,
          position: 'bottom',
          content: this.innerContent
        });

      }

      this.userModal.open();
    },

    bindEvents: function(insideContent) {

      insideContent.on('click', '[data-remodal-action="cancel"]', _.bind(function(e) {
        e.preventDefault();
        this.cancel();
      }, this));

      insideContent.on('click', '[data-remodal-action="confirm"]', _.bind(function(e) {
        e.preventDefault();
        this.confirm();
      }, this));

    },

    confirm: function() {
      var changeNameFieldVal = this.userModal.tooltipster._$tooltip.find('input').val();

      if (changeNameFieldVal.length >= this.minlength && changeNameFieldVal.length <= this.maxlength) {
        this.userModal.$el.removeClass('lengthError');
        mediator.trigger(config.events.designCenter.changeProjectName, this.projectId, changeNameFieldVal);
        this.$headerTitle.text(changeNameFieldVal);
        this.userModal.close();
      } else {
        this.userModal.tooltipster.$tooltip.addClass('lengthError');
      }
    },

    cancel: function() {
      this.userModal.close();
    }

  }, {
    create: function($parent) {
      $parent.find('.js-changeProjectName').each(function(n, el) {
        new ChangeProjectNameControl({
          el: el
        });
      });
    }
  });

module.exports = ChangeProjectNameControl;


// WEBPACK FOOTER //
// ./assets/components/DesignCenter/ChangeProjectNameControl.js